<template>
  <div v-if="visible" class="leo-operator-assistant-host">
    <button
      type="button"
      class="leo-operator-assistant-fab"
      title="训练平台操作助手"
      @click="openAssistant"
    >
      操作助手
    </button>
    <leo-training-operator-assistant />
  </div>
</template>

<script>
import LeoTrainingOperatorAssistant from '@/components/LeoKnowledge/LeoTrainingOperatorAssistant.vue'
import { openLeoOperatorAssistant, routeShowsOperatorAssistant } from '@/utils/leoOperatorAssistant'

export default {
  name: 'LeoTrainingOperatorAssistantHost',
  components: { LeoTrainingOperatorAssistant },
  computed: {
    visible () {
      return routeShowsOperatorAssistant(this.$route)
    }
  },
  methods: {
    openAssistant () {
      openLeoOperatorAssistant()
    }
  }
}
</script>

<style scoped>
.leo-operator-assistant-fab {
  position: fixed;
  left: 20px;
  bottom: 24px;
  z-index: 1900;
  border: none;
  border-radius: 999px;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #409eff, #337ecc);
  box-shadow: 0 4px 14px rgba(64, 158, 255, 0.45);
  cursor: pointer;
}
.leo-operator-assistant-fab:hover {
  filter: brightness(1.05);
}
</style>



// WEBPACK FOOTER //
// src/components/LeoKnowledge/LeoTrainingOperatorAssistantHost.vue